





























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class TextField extends Vue {
  @Prop() type!: string;

  @Prop() autofocus?: boolean;

  @Prop() disabled?: boolean;

  @Prop() rules!: any;

  @Prop() label!: string;

  @Prop() value!: any;

  @Prop() counter?: number;

  @Prop() placeholder?: string;

  @Prop() maxlength?: number;

  @Prop() minDate?: any;

  @Prop({ type: Boolean, default: false }) loading!: boolean;

  @Prop({
    required: false,
    default: true,
  })
  private outline!: boolean;

  beforeUpdate() {
    this.informationValue(this.value);
  }

  informationValue(value: string) {
    this.$emit('input', value);
  }

  validate(force: boolean = true) {
    const input: any = this.$refs.input;
    if (input && typeof input.validate === 'function') {
      return input.validate(force);
    }
    return true;
  }
}
